import React, { Component, Fragment } from 'react';
import './AdvancedFilter.css';
import CarAdvancedFilter from '../../CarAdvancedFilter';

import { FilterIcon, CloseIcon } from '../../../../../common/icons';
import AirButton from '../../../../../common/components/AirButton';
import { inject, observer } from 'mobx-react';

@inject('translationsStore','carsStore')
@observer
export default class AdvancedFilter extends Component {
  constructor(props) {
    super(props);

    this.CarAdvancedFilterRef = React.createRef();

    this.state = {
      isClosed: false,
      showDrawer: false
    };
  }

  componentDidMount = () => {
    this.CarAdvancedFilterInstance = this.CarAdvancedFilterRef.current.wrappedInstance;
  };

  render() {
    const { translationsStore, carsStore } = this.props;

    let appliedFiltersLength = 0;
    if (carsStore.appliedFilters.models) {
      appliedFiltersLength++;
    }
    if (carsStore.appliedFilters.alimentation) {
      appliedFiltersLength++;
    }
    if (carsStore.appliedFilters.registrationYearMin && carsStore.appliedFilters.registrationYearMax ) {
      appliedFiltersLength++;
    }
    if (carsStore.appliedFilters.totalKmMin && carsStore.appliedFilters.totalKmMax ) {
      appliedFiltersLength++;
    }

    return (
      <div className="AdvancedFilter">
        {!!this.state.isClosed && (
          <div className="AdvancedFilterInner">
            <div>
              <FilterIcon style={{ color: 'white' }} />
            </div>
            <div>{translationsStore.translate('advancedfilter.filters')}</div>
          </div>
        )}
        {!this.state.isClosed && (
          <Fragment>
            {!appliedFiltersLength && (
              <AirButton
                onClick={() => {
                  carsStore.loadFilters().then(() => {
                    this.CarAdvancedFilterInstance.show();
                  });
                }}
                className="openFilter"
                icon={<FilterIcon style={{ color: 'white' }} />}
                label={translationsStore.translate('advancedfilter.filters')}
              />
            )}
            {appliedFiltersLength > 0 && (
              <div className="filterActiveButton">
                <FilterIcon
                  style={{ color: 'white', width: '18px', height: '12px' }}
                  className="filterIcon"
                  onClick={() => {
                    carsStore.loadFilters().then(() => {
                      this.CarAdvancedFilterInstance.show();
                    });
                  }}
                />
                <div>
                  {translationsStore.translate('advancedfilter.filters')} {appliedFiltersLength}
                </div>
                <CloseIcon
                  title="reset"
                  style={{ color: 'white', width: '14px', height: '14px' }}
                  className="closeIcon"
                  onClick={() => {
                    this.CarAdvancedFilterInstance.reset();
                    this.setState({ appliedFiltersLength: 0 });
                  }}
                />
              </div>
            )}
          </Fragment>
        )}
        <CarAdvancedFilter
          cars={carsStore.filtered}
          visible={this.state.showDrawer}
          onApply={this.onApply}
          ref={this.CarAdvancedFilterRef}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/AdvancedFilter/AdvancedFilter.js